import { axiosInstance } from './instance';
import type { Student, Campus, SearchStudentsOutput, SearchCampusesOutput, ShiftDetails, SearchShiftsOutput } from './types/smithy';

export type { Student, Campus, SearchStudentsOutput, SearchCampusesOutput };
export type { ShiftDetails as Shift };
export type { ShiftDetails, SearchShiftsOutput };

/**
 * Fetch campuses by IDs
 */
export const getCampusesByIds = async (campusIds: string[]): Promise<SearchCampusesOutput> => {
  if (!campusIds.length) return { campuses: [] };

  try {
    const uniqueIds = [...new Set(campusIds)];
    const searchQuery = `@id:(${uniqueIds.join(' | ')})`;

    const response = await axiosInstance.get('/campuses/search', {
      params: {
        query: searchQuery,
        limit: 100,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching campuses:', error);
    return { campuses: [] };
  }
};

/**
 * Fetch shifts by IDs
 */
export const getShiftsByIds = async (shiftIds: string[]): Promise<SearchShiftsOutput> => {
  if (!shiftIds.length) return { shifts: [] };

  try {
    const uniqueIds = [...new Set(shiftIds)];
    const searchQuery = `@id:(${uniqueIds.join(' | ')})`;

    const response = await axiosInstance.get('/shifts/search', {
      params: {
        query: searchQuery,
        limit: 100,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching shifts:', error);
    return { shifts: [] };
  }
};

export const getStudentsByParentId = async (
  parentId: string,
): Promise<SearchStudentsOutput> => {
  try {
    const response = await axiosInstance.get('/students/search', {
      params: {
        query: `(@primaryParentId:{${parentId}}) | (@secondaryParentId:{${parentId}})`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching students:', error);
    throw error;
  }
};

export const getUserById = async (userId: string) => {
  try {
    const response = await axiosInstance.get(`/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
};
